import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuditService } from '@core/services/audit.service';
import { catchError, throwError } from 'rxjs';
import { UserService } from '@core/services/user.service';

export const auditHttpInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/audit')) {
    return next(req);
  }

  const audit = inject(AuditService);
  const router = inject(Router);
  const start = performance.now();
  const userService = inject(UserService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      audit.logError({
        applicationName: 'LRP Proveedores Frontend',
        requestMethod: req?.method || '',
        requestPath: req?.url || '',
        requestBody: safeBody(req.body),
        responseBody: safeBody(error.error),
        statusCode: error?.status || 0,
        statusDescription: error?.statusText || '',
        executionTimeMs: Math.round(performance.now() - start),
        frontendRoute: router?.url || '',
        exception: error?.message || '',
        userAgent: navigator?.userAgent || '',
        browser: getBrowser(),
        userId: userService?.userName() || '',
      });

      return throwError(() => error);
    }),
  );
};

function safeBody(body: any): string {
  if (body === null || body === undefined) return '[empty]';
  try {
    return JSON.stringify(body);
  } catch {
    return '[unserializable]';
  }
}

function getBrowser(): string {
  const ua = navigator.userAgent;
  if (ua.includes('Chrome')) return 'Chrome';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Safari')) return 'Safari';
  return 'Unknown';
}
